import { axiosRef } from '../../../api';

export default async function getCarrierDropdown(
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `/carrier_dropdown?is_pagination=False`;

  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const carrierList = response.data.content.map((datum: any): any => ({
        id: datum?.id,
        label: datum?.name,
        value: datum?.code,
      }));

      return {
        carrierList,
      };
    }
    setLoading(false);
    return {
      carrierList: [],
    };
  } catch (error) {
    setLoading(false);
    return {
      carrierList: [],
    };
  }
}
